import pym from "./ext/pym.v1.min.js";
window.pym = pym;

export const initIframePym = () => {

    $("iframe.pym").each(function (i, nodo) {
        var id = $(nodo).data('id') || ('pymnro' + i),
            url = $(nodo).attr('src') || $(nodo).data('src'),
            opts = /*$(nodo).data('opts') || HAY QUE PARSEAR JSON*/ {};

        if (!!url) {
            $(nodo).after('<div id="' + id + '"></div>');
            $(nodo).remove();

            var mypym = new pym.Parent(id, url, opts);
            mypym.onMessage('pymEspecialesLoaded', function (status) {
                if (status === 'ready')
                    mypym.sendMessage('setShareUrl', document.URL);
            });
        }
    });
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/pymFunction.js